// import { useEffect, useState } from "react";
// import { Button, Flex, Modal, message, Table, Input, Spin, Switch } from "antd";
// import {
//   EditOutlined,
//   DeleteOutlined,
//   SearchOutlined,
// } from "@ant-design/icons";
// import {
//   deleteRole,
//   fetchRole,
//   postRole,
//   putRole,
// } from "../Service/roleService";
// import RoleForm from "./roleForm";

// let searchTimeout = null; // simple debounce

// const Role = () => {
//   const [categories, setCategories] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [page, setPage] = useState(1);
//   const [size, setSize] = useState(50);
//   const [search, setSearch] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editData, setEditData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();

//   const fetchData = async (
//     pageNum = page,
//     pageSize = size,
//     searchText = search
//   ) => {
//     setLoading(true);
//     try {
//       const res = await fetchRole({
//         page: pageNum - 1,
//         size: pageSize,
//         role: searchText || undefined,
//       });

//       setCategories(res.data.data);
//       setTotal(res.data.totalElements);
//       setPage(pageNum);
//       setSize(pageSize);
//     } catch (err) {
//       message.error("Network error while fetching categories");
//     }
//     setLoading(false);
//   };

//   const saveData = async (data) => {
//     setLoading(true);
//     try {
//       if (editData) {
//         await putRole(data, editData.id);
//       } else {
//         await postRole(data);
//       }
//       messageApi.open({
//         type: "success",
//         content: `Role ${editData ? "updated" : "added"} successfully`,
//       });
//       handleCancel();
//       fetchData();
//       return true;
//     } catch (err) {
//       messageApi.open({
//         type: "error",
//         content: "Error while saving role",
//       });
//       return false;
//     } finally {
//       setLoading(false);
//     }
//   };

//   const deleteData = async (id) => {
//     try {
//       await deleteRole(id);
//       messageApi.open({
//         type: "success",
//         content: "Role deleted successfully",
//       });
//       fetchData();
//     } catch (err) {
//       messageApi.open({
//         type: "error",
//         content: "Error while deleting role",
//       });
//     }
//   };

//   const handleCancel = () => {
//     setIsModalOpen(false);
//     setEditData(null);
//   };

//   // 🔎 auto search effect with debounce
//   useEffect(() => {
//     clearTimeout(searchTimeout);
//     searchTimeout = setTimeout(() => {
//       fetchData(1, size, search);
//     }, 500); // wait 500ms after typing stops

//     return () => clearTimeout(searchTimeout);
//   }, [search]);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const columns = [
//     {
//       title: "Role",
//       dataIndex: "roleName",
//       key: "roleName",
//     },
//     {
//       title: "Organization",
//       dataIndex: "firm",
//       key: ["firm", "name"],
//     },
//     {
//       title: "Status",
//       dataIndex: "active",
//       key: "active",
//       render: (data) => (
//         <Switch
//           checkedChildren="Active"
//           unCheckedChildren="Inactive"
//           checked={data}
//           disabled
//         />
//       ),
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       render: (_, record) => (
//         <>
//           <EditOutlined
//             style={{ marginRight: 12, cursor: "pointer" }}
//             onClick={() => {
//               setEditData(record);
//               setIsModalOpen(true);
//             }}
//           />
//           <DeleteOutlined
//             style={{ cursor: "pointer" }}
//             onClick={() => deleteData(record.id)}
//           />
//         </>
//       ),
//     },
//   ];

//   return (
//     <Spin spinning={loading}>
//       <div style={{ width: "100%" }}>
//         {contextHolder}
//         <Flex
//           justify="space-between"
//           align="center"
//           style={{ marginBottom: 16 }}
//         >
//           <div style={{ fontSize: "1rem", fontWeight: 700 }}>Role</div>
//           <Flex gap={8}>
//             <Input
//               placeholder="Search role"
//               prefix={<SearchOutlined />}
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//             <Button onClick={() => setIsModalOpen(true)} type="primary">
//               Add
//             </Button>
//           </Flex>
//         </Flex>

//         <Table
//           rowKey="id"
//           columns={columns}
//           dataSource={categories}
//           loading={loading}
//           bordered
//           pagination={{
//             current: page,
//             pageSize: size,
//             total: total,
//             onChange: (p, ps) => fetchData(p, ps, search),
//             showSizeChanger: true,
//           }}
//         />

//         <Modal
//           title="Role Form"
//           centered
//           closable
//           open={isModalOpen}
//           footer={false}
//           onCancel={handleCancel}
//         >
//           <RoleForm editData={editData} saveData={saveData} />
//         </Modal>
//       </div>
//     </Spin>
//   );
// };

// export default Role;
import { useEffect, useState } from "react";
import { Button, Flex, Modal, message, Table, Input, Spin, Switch } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  deleteRole,
  fetchRole,
  postRole,
  putRole,
} from "../Service/roleService";
import RoleForm from "./roleForm";

let searchTimeout = null;

const Role = () => {
  const [roles, setRoles] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(50);
  const [search, setSearch] = useState("");
  const [sortField, setSortField] = useState("createdDate");
  const [sortOrder, setSortOrder] = useState("descend");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  // ================= FETCH =================
  const fetchData = async (
    pageNum = page,
    pageSize = size,
    searchText = search,
    field = sortField,
    order = sortOrder
  ) => {
    setLoading(true);
    try {
      const res = await fetchRole({
        page: pageNum - 1,
        size: pageSize,
        search: searchText || "",
        sort: field,
        desc: order === "descend",
      });

      setRoles(res.data.content || []);
      setTotal(res.data.totalElements || 0);
      setPage(pageNum);
      setSize(pageSize);
      setSortField(field);
      setSortOrder(order);
    } catch {
      messageApi.error("Network error while fetching roles");
    } finally {
      setLoading(false);
    }
  };

  // ================= SAVE =================
  const saveData = async (data) => {
    setLoading(true);
    try {
      if (editData) {
        await putRole(data, editData.id);
      } else {
        await postRole(data);
      }
      messageApi.success(`Role ${editData ? "updated" : "added"} successfully`);
      handleCancel();
      fetchData();
      return true;
    } catch {
      messageApi.error("Error while saving role");
      return false;
    } finally {
      setLoading(false);
    }
  };

  // ================= DELETE =================
  const deleteData = async (id) => {
    try {
      await deleteRole(id);
      messageApi.success("Role deleted successfully");
      fetchData();
    } catch {
      messageApi.error("Error while deleting role");
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setEditData(null);
  };

  // ================= SEARCH (DEBOUNCE) =================
  useEffect(() => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      fetchData(1, size, search);
    }, 500);

    return () => clearTimeout(searchTimeout);
  }, [search]);

  useEffect(() => {
    fetchData();
  }, []);

  // ================= COLUMNS =================
  const columns = [
    {
      title: "Role",
      dataIndex: "roleName",
      key: "roleName",
      sorter: true,
      sortOrder: sortField === "roleName" ? sortOrder : null,
    },
    {
      title: "Organization",
      dataIndex: ["firm", "name"],
      key: "organization",
      sorter: true,
      sortOrder: sortField === "firm" ? sortOrder : null,
    },
    {
      title: "Status",
      dataIndex: "active",
      key: "active",
      render: (val) => (
        <Switch
          checked={val}
          disabled
          checkedChildren="Active"
          unCheckedChildren="Inactive"
        />
      ),
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <>
          <EditOutlined
            style={{ marginRight: 12, cursor: "pointer" }}
            onClick={() => {
              setEditData(record);
              setIsModalOpen(true);
            }}
          />
          <DeleteOutlined
            style={{ cursor: "pointer" }}
            onClick={() => deleteData(record.id)}
          />
        </>
      ),
    },
  ];

  return (
    <Spin spinning={loading}>
      <div style={{ width: "100%" }}>
        {contextHolder}

        <Flex
          justify="space-between"
          align="center"
          style={{ marginBottom: 16 }}
        >
          <div style={{ fontSize: "1rem", fontWeight: 700 }}>Role</div>
          <Flex gap={8}>
            <Input
              placeholder="Search"
              prefix={<SearchOutlined />}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Button type="primary" onClick={() => setIsModalOpen(true)}>
              Add
            </Button>
          </Flex>
        </Flex>

        <Table
          rowKey="id"
          columns={columns}
          dataSource={roles}
          bordered
          pagination={{
            current: page,
            pageSize: size,
            total,
            showSizeChanger: true,
          }}
          onChange={(pagination, filters, sorter) => {
            const field = sorter.field || sortField;
            const order = sorter.order || sortOrder;

            fetchData(
              pagination.current,
              pagination.pageSize,
              search,
              field,
              order
            );
          }}
        />

        <Modal
          title={editData ? "Edit Role" : "Add Role"}
          centered
          open={isModalOpen}
          footer={false}
          onCancel={handleCancel}
        >
          <RoleForm editData={editData} saveData={saveData} />
        </Modal>
      </div>
    </Spin>
  );
};

export default Role;
